/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

function ShareIcon({ color }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.13073e-05 9.98823C-0.00847383 12.1252 1.71702 13.8646 3.85404 13.8731C4.83823 13.8769 5.78694 13.5056 6.50704 12.8347L12.2733 15.4382C12.2332 15.6538 12.2113 15.8724 12.2075 16.0916C12.2008 18.2434 13.9395 19.9931 16.0913 20C18.2429 20.0068 19.9928 18.268 19.9996 16.1163C20.0064 13.9646 18.2676 12.2147 16.1159 12.2079C14.8304 12.2039 13.6255 12.8342 12.8959 13.8926L7.47834 11.4465C7.86314 10.5173 7.86463 9.47365 7.48252 8.5434L12.8925 6.08471C14.1108 7.84664 16.5267 8.28735 18.2886 7.06912C20.0505 5.85089 20.4912 3.43503 19.273 1.6731C18.0548 -0.0888421 15.6389 -0.52955 13.8769 0.68868C12.8276 1.4142 12.2022 2.60925 12.2042 3.88495C12.2077 4.10452 12.2299 4.32336 12.2708 4.53915L6.51952 7.15257C4.96132 5.68941 2.51202 5.76646 1.04886 7.32466C0.371684 8.04589 -0.00363606 8.99898 3.13073e-05 9.98823Z"
        fill={color}
      />
    </svg>
  );
}
ShareIcon.propTypes = {
  color: PropTypes.string,
};

ShareIcon.defaultProps = {
  color: '#B8C7D8',
};

export default ShareIcon;
